import { WaitLoadingService } from './../../components/common/waitLoading/wait-loading.service';
import { AppConfiguration } from './../../conf/app.configuration';
import { TranslateService } from '@ngx-translate/core';
import { Component, Input, AfterContentInit } from '@angular/core';
import { ServiceLocator } from '../../ServiceLocator';
import { DossierDTO, FavouriteProjectDTO, UserDTO } from '../../api/plyca-dtos';
import { ProjectEntityDTO } from '../../api/plyca-dtos-v2';
import { UIService } from '../../ui.service';
import { Location } from '@angular/common';
import { PlycaDataService } from '../../../services/plyca.service';
import { dossierBasicInfoComponent } from './dossierBasicInfo.component';
import { Router } from '@angular/router';
import { UserService } from '../../user.service';
import { Configuration } from '../../conf/app.constants';
import { DocumentService } from '../../documents/document.service';
import { DialogService, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { BaseComponent } from '../../components/common/baseComponent/base.component';
import { calendarComponent } from '../../calendar/calendar.component';
import { HelpService } from '../../components/common/help/help.service';
import { switchMap } from 'rxjs/operators';
import { UserPrefsService } from '../../store/user-prefs.service';

@Component({
  selector: 'dossierHeader',
  templateUrl: 'dossierHeader.template.html',
  providers: [DialogService, DocumentService]
})
export class dossierHeaderComponent extends BaseComponent implements AfterContentInit {


  @Input() backVisible = true;
  @Input() infoVisible = true;
  @Input() favouriteVisible = true;
  @Input() showDocumentsVisible = false;
  @Input() showCalendarVisible = false;
  @Input() division = 0;

  @Input() title = '';
  @Input() titleIcon = '';

  dossierLoaded = false;
  favouriteChanging = false;
  private plycaService: PlycaDataService;
  private location: Location;


  modoBasico = true; // modo de visualizacion
  project: ProjectEntityDTO;
  private _projectId: any;
  @Input()
  set projectId(projectId: any) {
    if (projectId) {
      this._projectId = projectId;
      this.project = null;
      this.dossierLoaded = false;
      this.subscribe(this.plycaService.get(
        this.configuration.PROJECTENTITY_SERVICE_URL, projectId,
        this.getQueryParams()), (param: ProjectEntityDTO) => {
          this.project = param;
          this.dossierLoaded = true;
        });
    }
  }


  constructor(
    public uiService: UIService,
    protected router: Router,
    protected documentService: DocumentService,
    public configuration: Configuration,
    public dialogService: DialogService,
    private translateService: TranslateService,
    private waitService: WaitLoadingService,
    public helpService: HelpService,
    private appConfig: AppConfiguration,
    private userPrefsService: UserPrefsService,
    private userService: UserService
  ) {
    super();
    this.subscribe(this.userPrefsService.getUserPrefs());
    this.location = ServiceLocator.injector.get(Location);
    this.plycaService = ServiceLocator.injector.get(PlycaDataService);
  }

  ngAfterContentInit(): void {
    if (this.appConfig.getValue('calendar.enabled.profiles') !== undefined
      && !this.userService.hasRoles(this.appConfig.getValue('calendar.enabled.profiles'))) {
      this.showCalendarVisible = false;
    }
  }

  private getQueryParams() {
    return {
      expand: 'expansionSet:webclient'
    };
  }



  toogleFavourite() {

    if (this.project && this.project.favourite) {
      this.favouriteChanging = true;
      this.subscribe(this.plycaService.delete(this.configuration.FAVOURITE_SERVICE_URL, this.project.favourite.identifier),
        response => {
          console.log('Eliminado favorito...');
          this.project.favourite = undefined;
          this.favouriteChanging = false;
        },
        error => {
          console.log('Error al eliminar favorito:' + error);
        }
      );

    } else {

      let fav = new FavouriteProjectDTO();
      fav.project = {} as ProjectEntityDTO;
      fav.user = new UserDTO();
      fav.project.identifier = this.project.identifier;
      fav.user.identifier = this.userService.getUserId();
      this.favouriteChanging = true;
      this.subscribe(this.plycaService.insert<FavouriteProjectDTO>(this.configuration.FAVOURITE_SERVICE_URL, fav),
        response => {
          console.log('Insertado favorito...');
          this.project.favourite = response;
          this.favouriteChanging = false;

        },
        error => {
          console.log('Error al insertar favorito:' + error);
        }
      );


    }

  }

  classFavourite(): string {
    if (!this.project) {
      return 'hidden';
    } else if (this.project.favourite) {
      return 'fa-star text-warning';
    } else {
      return 'fa-star text-secondary';
    }
  }

  openDossier(dossier: DossierDTO) {
    this.uiService.openDossier(dossierBasicInfoComponent, undefined, dossier.identifier);
    // this.router.navigate(['/dossierInfo/' + this.dossier.identifier]);
  }

  routeBack() {
    this.uiService.routeBack();
  }

  showDocuments() {
    if (this.project.identifier) {
      let text = this.project.abbreviatedTitle != undefined ? ': ' + this.project.abbreviatedTitle : ''
      let title = this.project.contractFolderId + text;
      this.documentService.openDossierDocumentsDialog(this.project.identifier, title);
    }
  }






  showCalendar() {

    let config: DynamicDialogConfig = {
      header: this.translateService.instant('Calendar.title'),
      width: '70%',
      style: { 'max-height': '80%' },
      styleClass: 'formEdition',
    };

    config['id'] = 'new';
    if (this.project.identifier) {
      config['project'] = this.project
    }
    config['division'] = this.division;
    config['isModalWindow'] = true;

    this.waitService.startWaiting();
    let curentHelpTags = [];
    this.subscribe(
      this.helpService.getStoreTagsObservable().pipe(
        switchMap((helpTags) => curentHelpTags = helpTags)));

    const ref = this.dialogService.open(calendarComponent, config);

    this.subscribe(ref.onClose.pipe(
      switchMap(() => this.helpService.showContextHelpObservable(curentHelpTags))));

  }

  truncateDivisionDescription(name: string) {
    if (!name)
      return '';
    if (name.length > 200)
      return name.substring(0, 200) + " ...";
    else
      return name;
  }

}
